<template lang="pug">
  div
    v-img(:src="code" max-width="200px")
    v-btn(@click="createQRCode()" v-if="code==''") Get QR Code
    v-btn(v-if="code!=''" :href="code" download) Download
</template>


<script>
import QRCode from "qrcode/build/qrcode"
export default {
  name: "QRCode",
  props: ["info"],
  components:{QRCode},
  data:()=>({
    code:''
  }),
  methods:{
    createQRCode(){
      QRCode.toDataURL(JSON.stringify(this.info), (err, url)=>{
        this.code = url
      })
    }
  },

}




</script>

